// extracted by mini-css-extract-plugin
export default {"container_item":"Item_container_item__Dlr7C","item_icon":"Item_item_icon__1Stuk","overlay":"Item_overlay__d5YRM","item_desc":"Item_item_desc__OiV2e"};